<script setup lang="ts">
import { resolveBlogPostOutcome, type BlogPostQueryError } from '../utils/resolveBlogPostOutcome'

definePageMeta({
    hidePromotions: true
})

const route = useRoute()
const slug = route.params?.slug as string

const blogPost = await useBlogPost(slug)

const post = computed(() => blogPost.data.value?.post ?? null)
const error = blogPost.error.value as BlogPostQueryError | null

const outcome = resolveBlogPostOutcome(error, !!post.value)

// 302 never 301 — a later-published slug must not be cached as permanently moved.
if (outcome.kind === 'redirect') {
    await navigateTo('/blog', { redirectCode: 302 })
}
else if (outcome.kind === 'error') {
    throw createError({
        statusCode: outcome.statusCode,
        statusMessage: outcome.statusMessage,
        fatal: true,
    })
}
</script>

<template>
    <NimbusBlogDetails
        v-if="post"
        :post="post"
    />
</template>
